<script setup lang="ts">
import { useField, useForm } from "vee-validate";
import * as yup from "yup";

import type { LoginDto } from "~/common/interfaces/dto/auth/login.dto";

const emit = defineEmits(["submit"]);

const { t } = useI18n();
const { errors, handleSubmit } = useForm<LoginDto>({
	validationSchema: yup.object({
		email: yup
			.string()
			.required(t("INPUT.email.error.required"))
			.email(t("INPUT.email.error.email")),
		password: yup
			.string()
			.required(t("INPUT.password.error.required"))
	})
});

const onSubmit = handleSubmit((dto: LoginDto) => {
	emit("submit", dto);
});

const { value: email } = useField<string>("email");
const { value: password } = useField<string>("password");
</script>

<template>
	<AppModal
		:title="$t('COMMON.login')"
		:submit-button-text="$t('COMMON.login')"
		:backdrop="false"
		@submit="onSubmit"
	>
		<span class="font-semibold text-base">
			{{ $t('COMMON.credentials') }}
		</span>
		<div class="mt-4 flex flex-col gap-y-2">
			<AppInput
				v-model="email"
				name="email"
				type="email"
				:title="$t('COMMON.email')"
				:placeholder="$t('INPUT.PLACEHOLDER.email')"
				required
				:error="errors.email"
			/>
			<AppInput
				v-model="password"
				name="password"
				type="password"
				:title="$t('COMMON.password')"
				:placeholder="$t('INPUT.PLACEHOLDER.password')"
				required
				:error="errors.password"
			/>
		</div>
	</AppModal>
</template>
